<template>
  <v-container fluid class="pa-0" fill-height>
    <div v-if="error" class="form-error">
      <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
    </div>
    <template>
      <v-layout align-space-around column fill-height>
        <v-img
          :src="require('@/assets/ondulacao.svg')"
          cover
          fill-height
          style="height: 200px"
          position="top right"
        >
          <v-layout align-space-around row fill-height>
            <template v-if="!$vuetify.breakpoint.xs">
              <v-flex lg4 md5 sm5 class="ml-5 titulo form-flex">
                <v-layout align-space-around justify-space-between column fill-height>
                  <v-flex class="text-xs-left pt-3 texto">
                    <img
                      class="logo"
                      :src="require('@/assets/logomarca.png')"
                      alt="Apetrus logomarca"
                    />
                    <div
                      class="headline blue--text darken-4"
                    >{{ !user ? 'Seu posto de combustível' : 'Seja bem-vindo ao' }}</div>
                    <div
                      style="color:#074d6e"
                      class="font-weight-medium display-1"
                    >{{ !user ? 'Em uma nova era de abastecimento' : 'seu mais novo canal direto de vendas mobile' }}</div>
                  </v-flex>

                  <template v-if="!user">
                    <v-flex class="text-xs-left">
                      <v-form class="form" ref="form" v-model="valid" lazy-validation>
                        <v-alert v-model="loginErro" type="error" outline>
                          <h4>Atenção!</h4>
                          {{errorMessage}}
                        </v-alert>

                        <v-text-field v-model="login.email" box label="E-mail"></v-text-field>

                        <v-text-field v-model="login.password" box label="Senha" type="password"></v-text-field>

                        <div class="cadastro mb-3">
                          <span>
                            Esqueceu sua senha?
                            <a @click="sendResetMail = true">Alterar</a>
                          </span>
                        </div>

                        <div>
                          <v-layout row align-space-around>
                            <v-btn
                              block
                              round
                              dark
                              :loading="loading"
                              :disabled="loading"
                              color="secondary"
                              class="white--text btnLogin"
                              @click="fazerLogin"
                            >Entrar</v-btn>

                            <v-spacer></v-spacer>

                            <v-btn
                              block
                              flat
                              :loading="loading"
                              :disabled="loading"
                              color="secondary"
                              class="white--text btnLogin"
                              @click="dialogCad=true"
                            >Cadastre-se</v-btn>
                          </v-layout>
                        </div>
                      </v-form>
                    </v-flex>
                  </template>
                  <template v-else>
                    <v-flex class="text-xs-left">
                      <h1>Seguir como:</h1>
                      <v-chip color="primary" dark close @input="logout()">
                        <v-avatar>
                          <img v-if="user.image" :src="user.image" alt="trevor" />
                          <v-icon v-else>account_circle</v-icon>
                        </v-avatar>
                        {{ user.email }}
                      </v-chip>
                    </v-flex>
                    <v-flex class="pa-5">
                      <v-btn
                        block
                        round
                        v-if="!isUserVerified"
                        color="error"
                        dark
                        @click="resendEmail"
                      >Usuário não verificado, reenviar e-mail!</v-btn>
                      <v-btn
                        v-else
                        block
                        round
                        :loading="loading"
                        :disabled="loading"
                        color="success"
                        class="white--text btnLogin"
                        @click="$router.push(lastPage ? lastPage : '/home')"
                      >Continue</v-btn>
                    </v-flex>
                  </template>
                </v-layout>
              </v-flex>

              <v-flex lg8 md7 sm7 class="tablet pl-5 pt-5 pb-0 pr-0" justify-center align-center>
                <v-layout align-center justify-end fill-height row>
                  <img
                    align-self-center
                    class="imgTablet"
                    :src="require('@/assets/smartphone.svg')"
                    alt="Apetrus tablet"
                  />
                </v-layout>
              </v-flex>
            </template>

            <template v-else>
              <v-flex xs12>
                <v-layout align-space-around justify-space-between column fill-height>
                  <v-flex class="text-xs-left" shrink pl-2>
                    <img
                      class="logo"
                      :src="require('@/assets/logomarca.png')"
                      alt="Apetrus logomarca"
                    />
                  </v-flex>

                  <v-spacer></v-spacer>

                  <v-flex class="text-xs-center pt-3 texto">
                    <div
                      style="color:white"
                      class="font-weight-medium display-1"
                    >{{ !user ? 'Viva uma nova experiência em abastecimento' : 'Bem-vindo ao universo de abastecimento barato' }}</div>
                  </v-flex>

                  <template v-if="!user">
                    <v-flex>
                      <v-form
                        v-if="!user"
                        dark
                        class="form m-auto"
                        ref="form"
                        v-model="valid"
                        lazy-validation
                      >
                        <v-alert v-model="loginErro" type="error" outline>
                          <h4>Atenção!</h4>
                          {{errorMessage}}
                        </v-alert>

                        <v-text-field
                          v-model="login.email"
                          dark
                          class="pb-3"
                          hide-details
                          box
                          label="E-mail"
                        ></v-text-field>

                        <v-text-field
                          hide-details
                          dark
                          class="pb-1"
                          v-model="login.password"
                          box
                          label="Senha"
                          type="password"
                        ></v-text-field>

                        <div class="cadastro white--text mb-3">
                          <span>
                            Esqueceu sua senha?
                            <a @click="sendResetMail = true" class="secondary--text">Alterar</a>
                          </span>
                        </div>

                        <div>
                          <v-layout row align-space-around>
                            <v-btn
                              block
                              round
                              dark
                              :loading="loading"
                              :disabled="loading"
                              color="secondary"
                              class="white--text btnLogin"
                              @click="fazerLogin"
                            >Entrar</v-btn>

                            <v-spacer></v-spacer>

                            <v-btn
                              block
                              flat
                              :loading="loading"
                              :disabled="loading"
                              color="secondary"
                              class="white--text btnLogin"
                              @click="dialogCad=true"
                            >Cadastre-se</v-btn>
                          </v-layout>
                        </div>
                      </v-form>
                    </v-flex>
                  </template>
                  <template v-else>
                    <v-flex class="text-xs-center secondary--text">
                      <h1>Seguir como:</h1>
                      <v-chip color="primary" dark close @input="logout()">
                        <v-avatar>
                          <img v-if="user.image" :src="user.image" alt="trevor" />
                          <v-icon v-else>account_circle</v-icon>
                        </v-avatar>
                        {{ user.email }}
                      </v-chip>
                    </v-flex>
                    <v-flex class="button-over pa-3">
                      <v-layout>
                        <v-btn
                          block
                          round
                          v-if="!isUserVerified"
                          color="error"
                          dark
                          @click="resendEmail"
                        >Usuário não verificado, reenviar e-mail!</v-btn>
                        <v-btn
                          v-else
                          block
                          round
                          :loading="loading"
                          :disabled="loading"
                          color="success"
                          class="white--text btnLogin"
                          @click="$router.push(lastPage ? lastPage : '/home')"
                        >Continue</v-btn>
                      </v-layout>
                    </v-flex>
                  </template>
                </v-layout>
              </v-flex>
            </template>
          </v-layout>
        </v-img>
      </v-layout>
    </template>

    <!----------------------dialog cadastro-------------------------->
    <v-dialog
      v-model="dialogCad"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card width="100%" height="100%">
        <iframe
          :src="url_cadastro"
          frameborder="0"
          :style="{width: '100%', height: '100%'}"
          ref="frameCad"
        ></iframe>
      </v-card>
    </v-dialog>
    <v-dialog lazy v-model="sendResetMail" width="350">
      <reset-password v-on:fechar="sendResetMail = false" v-on:sucesso="fecharDialogReset()"></reset-password>
    </v-dialog>
    <v-snackbar v-model="snackbar" color="info" :multi-line="true" :timeout="4000" :vertical="true">
      {{snackbar_text}}
      <v-btn flat @click="snackbar = false">Fechar</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import ResetPassword from '@/components/dialogs/SendResetPassword'
import settings from '@/settings'

export default {
  components: { ResetPassword },
  data: () => ({
    sendResetMail: false,
    snackbar: false,
    snackbar_text: null,
    url_cadastro: null,
    dialogCad: false,
    loginErro: false,
    errorMessage: '',
    valid: true,
    login: {
      email: '',
      password: '',
      tipo: ''
    },
    emailRules: [v => !!v || 'Insira seu E-mail!'],
    passwordRules: [v => !!v || 'Insira sua senha!']
  }),
  mounted () {
    this.url_cadastro = settings.urlCadastroUsuario
  },
  created () {
    window.addEventListener('message', e => {
      if (e.data === 'closing_cad') {
        this.dialogCad = false
      }
    }, false)
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    isUserVerified () {
      return this.user.emailVerified
    },
    lastPage () {
      return this.$store.getters.lastPage
    }
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    fecharDialogReset () {
      this.sendResetMail = false
      this.snackbar_text = 'Link enviado com sucesso, verifique seu e-mail'
      this.snackbar = true
    },
    fazerLogin () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('signUserIn', {
          email: this.login.email,
          password: this.login.password
        })
      }
    },
    logout () {
      this.$store.dispatch('signUserOut')
    },
    resendEmail () {
      this.$store.dispatch('sendVerifyEmail').then(() => {
        this.snackbar_text =
          'Link de verificação enviado, verifique seu e-mail'
        this.snackbar = true
      })
    }
  }
}
</script>
<style>
.banner {
  width: 100%;
}
.logo {
  width: 30%;
}

.form {
  width: 80%;
  z-index: 2;
  position: relative;
}

.m-auto {
  margin: auto;
}

.curva {
  width: 100%;
  position: absolute;
  right: 0;
  bottom: 0;
}

.onda {
  width: 100%;
  position: absolute;
  right: 0;
  bottom: 0;
}

.tablet {
  width: 100%;
  z-index: 2;
}

.imgCurva {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
}

.imgOnda {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
}

.imgTablet {
  width: 100%;
}

.cadastro * {
  font-size: 90%;
}

.logopequeno {
  width: 7%;
}

.form-error {
  z-index: 2;
  position: absolute;
  right: 0;
  top: 0;
  left: 0;
}

.form-flex:first-child,
.form-error:first-child,
.button-over {
  z-index: 2;
}

@media screen and (min-width: 601px) {
  .imgOnda {
    width: 100%;
  }
}
</style>
